const MILESTONE_EDITOR_COLUMN_WIDTHS = {
  actions: 76,
  name: 200,
  date: 120,
  duration: 100,
  money: 120,
  remove: 28
} as const

const MILESTONE_TABLE_COLUMN_WIDTHS = {
  name: 240,
  date: 120,
  duration: 110,
  money: 120
} as const

const MILESTONE_TABLE_WIDTH =
  MILESTONE_TABLE_COLUMN_WIDTHS.name +
  MILESTONE_TABLE_COLUMN_WIDTHS.date * 2 +
  MILESTONE_TABLE_COLUMN_WIDTHS.duration +
  MILESTONE_TABLE_COLUMN_WIDTHS.money

const columnFlex = (width: number) => `${width}px`

const stretchColumnFlex = (width: number) => `1 0 ${width}px`

export {
  MILESTONE_EDITOR_COLUMN_WIDTHS,
  MILESTONE_TABLE_COLUMN_WIDTHS,
  MILESTONE_TABLE_WIDTH,
  columnFlex,
  stretchColumnFlex
}
